import { dbPost, dbPut, dbDelete } from '../../apis/commonApi';

class SurveyListController {
  headerList = [
    {
      colNo: 0,
      key: 'selected',
      labelType: 'check',
      dataType: 'check',
      name: '선택',
      readonly: false,
    },
    {
      colNo: 1,
      key: 'aplyYmd',
      labelType: 'text',
      dataType: 'text',
      name: '조사일자',
      readonly: true,
    },
    {
      colNo: 2,
      key: 'se',
      labelType: 'text',
      dataType: 'badge',
      dataOption: 'white',
      name: '조사구분',
    },
    {
      colNo: 3,
      key: 'survey',
      labelType: 'text',
      dataType: 'text',
      name: '조사작업수',
    },
    {
      colNo: 4,
      key: 'workload',
      labelType: 'text',
      dataType: 'text',
      name: '부담작업수',
    },
    {
      colNo: 5,
      key: 'aplyUser',
      labelType: 'text',
      dataType: 'text',
      name: '조사자',
    },
    {
      colNo: 6,
      key: 'category1',
      labelType: 'text',
      dataType: 'badge',
      name: '체크리스트',
    },
    {
      colNo: 7,
      key: 'category2',
      labelType: 'text',
      dataType: 'badge',
      name: '영상업로드',
    },
    {
      colNo: 8,
      key: 'category3',
      labelType: 'text',
      dataType: 'badge',
      name: '기본조사표',
    },
    {
      colNo: 9,
      key: 'category4',
      labelType: 'text',
      dataType: 'badge',
      name: '증상조사표',
    },
    {
      colNo: 10,
      key: 'category5',
      labelType: 'text',
      dataType: 'badge',
      name: '현재상태',
    },
    {
      colNo: 11,
      key: 'maxDanger',
      labelType: 'text',
      dataType: 'badge',
      name: '분석결과(위험수준)',
    },
  ];

  constructor(
    store,
    modalService,
    validateService,
    refs,
    [searchParam, setSearchParam],
    { dataList, setDataList },
    navigate
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.tableRef = refs[0];
    this.searchParam = searchParam;
    this.setSearchParam = setSearchParam;
    this.dataList = dataList;
    this.setDataList = setDataList;
    this.navigate = navigate;
  }

  async init() {
    await this.setSearchParam({
      entSn: this.store.entSn,
      currentPage: 1,
      pageSize: 10,
    });
    this.fnSearch();
  }

  async fnSearch(currentPage = 1, updatedSearchParam = null) {
    const params = {
      ...(updatedSearchParam || this.searchParam),
      currentPage,
    };

    const validationRules = {
      entSn: { presence: true },
    };

    const altKey = {
      entSn: '기업',
    };

    if (
      await this.validateService.validateJsCall(params, validationRules, altKey)
    ) {
      return;
    }

    const url = '/aia/survey/list.do';

    try {
      let response = await dbPost(url, params);
      if (response && Array.isArray(response)) {
        const updatedDataList = response.map((item, index) => ({
          totalCount: item.totalCount,
          entSn: item.entSn,
          aiaAplyId: item.aiaAplyId,
          rowNo: index,
          selected: false,
          aplyYmd: this.formatDateYYYYMMDD(item.aplyYmd),
          se: item.seNm,
          seTp: item.se,
          survey: item.category2Cnt1,
          workload: item.workLoadCnt,
          aplyUser: item.aplyUser,
          category1: item.category1,
          category2: item.category2,
          category3: item.category3,
          category4: item.category4,
          category5: item.category5,
          maxDanger: item.maxDanger,
        }));
        this.setDataList(updatedDataList);
        if (this.tableRef.current) {
          this.tableRef.current.resetData(updatedDataList);
        }
      }
    } catch (error) {
      this.modalService.errorAlert('조회 중 오류가 발생했습니다.', () => {});
    }
  }

  formatDateYYYYMMDD(value) {
    if (!value) return '';
    const year = value.substring(0, 4);
    const month = value.substring(4, 6);
    const day = value.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  //신규조사등록 버튼
  async fnNewTask() {
    this.navigate('/ai/surveyCheck', {
      state: {
        flag: 'new',
      },
    });
    // if (!seNm) {
    //   this.modalService.errorAlert('정기 또는 수시를 선택해주세요');
    //   return;
    // }
    // const url = '/aia/aply/add.do';
    // const param = {
    //   entSn: this.searchParam.entSn,
    //   aplyUser: this.store.userId,
    //   se: seNm === '정기' ? 'A' : 'O',
    // };

    // try {
    //   const response = await dbPost(url, param);
    //   if (response instanceof Error) {
    //     this.modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
    //   } else {
    //     const aiaAplyId = response.id;
    //     this.navigate('/ai/surveyCheck', {
    //       state: {
    //         flag: 'new',
    //         aiaAplyId: aiaAplyId,
    //       },
    //     });
    //   }
    // } catch (error) {
    //   this.modalService.errorAlert('데이터 처리 중 에러가 발생했습니다.');
    // }
  }

  async fnCheckList(rowData) {
    this.navigate('/ai/surveyCheck', {
      state: {
        flag: 'ex',
        entSn: rowData.entSn,
        aiaAplyId: rowData.aiaAplyId,
      },
    });
  }

  async fnUploadVdo(rowData) {
    this.modalService.openModal(
      'UploadVdoForValidation',
      {
        entSn: rowData.entSn,
        aiaAplyId: rowData.aiaAplyId,
        vldAplyId: rowData.aiaAplyId,
        exprtCnsltId: rowData.exprtCnsltId,
      },
      () => {
        this.fnSearch();
      }
    );
  }

  async fnReqVideo(rowData) {
    this.navigate('/ai/reqVideo', {
      state: {
        flag: 'ex',
        entSn: rowData.entSn,
        aiaAplyId: rowData.aiaAplyId,
      },
    });
  }

  async fnResVideo(rowData) {
    this.navigate('/ai/resVideoList', {
      state: {
        flag: 'ex',
        entSn: rowData.entSn,
        aiaAplyId: rowData.aiaAplyId,
      },
    });
  }

  async fnBscSrvy(rowData) {
    this.navigate('/ai/basicSurveyFirst', {
      state: {
        flag: rowData.flag,
        entSn: rowData.entSn,
        aiaAplyId: rowData.aiaAplyId,
      },
    });
  }

  async fnSymptomList() {
    this.navigate('/ai/symptomList');
  }

  // async fnSymptomList() {
  //   this.navigate('/ai/symptomList', {
  //     state: {
  //     },
  //   });
  // }

  // 작업 테이블 헤더 체크박스
  async tableHeaderClick(info) {
    let tableData = this.tableRef.current.getDataList();

    if (info.keyVal === 'selected') {
      for (let index = 0; index < tableData.length; index++) {
        tableData[index].selected = info.val;
      }

      this.tableRef.current.setDataList(tableData);
    }
  }

  // 작업 테이블 셀 클릭
  async tableCellClick(info) {
    const rowData = this.tableRef.current.getRowObj(info.rowNo);

    if (info.key === 'category1') {
      this.fnCheckList(rowData);
    } else if (info.key === 'category2' && rowData.category1 == '완료') {
      if (rowData.category2 == '완료' || rowData.category2 == '부가정보입력') {
        this.fnResVideo(rowData);
      } else {
        if (rowData.seTp === 'V') {
          this.fnUploadVdo(rowData);
        } else {
          this.fnReqVideo(rowData);
        }
      }
    } else if (
      info.key === 'category3' &&
      (rowData.category2 == '완료' || rowData.category2 == '부가정보입력')
    ) {
      if (rowData.seTp !== 'V') {
        this.fnBscSrvy({
          ...rowData,
          flag: rowData.category3 === '미진행' ? 'new' : 'ex',
        });
      }
    } else if (info.key === 'category4') {
      if (rowData.seTp !== 'V') {
        this.fnSymptomList(rowData);
      }
    }
  }

  async searchParamChange(model, value) {
    this.setSearchParam(prev => ({ ...prev, [model]: value }));

    if (model === 'currentPage') {
      this.fnSearch(value);
    }
  }

  async handleChange(value) {
    this.setSearchParam(prev => ({ ...prev, seNm: value }));
  }
}

export default SurveyListController;
